import React, {createContext, useEffect} from 'react';

import withRecaptcha from '../../modules/auth/components/hocs/withRecaptcha';
import {loadRecaptcha} from '../../modules/auth/components/ui/recaptcha';
import {compose} from '../../modules/auth/utils/helpers';

export const RecaptchaContext = createContext();

const RecaptchaProvider = ({captchaProps, children}) => {
  useEffect(() => {
    loadRecaptcha('golos-naroad-recaptcha');
  }, []);

  return (
    <RecaptchaContext.Provider value={{captchaProps}}>
      {children}
      {captchaProps?.render()}
    </RecaptchaContext.Provider>
  );
};

export default compose(withRecaptcha)(RecaptchaProvider);
